import { createApp, ref, onMounted, watch, nextTick } from 'vue';
import { createPinia, storeToRefs } from 'pinia';
import layout from '@/style/layout.scss';
import $ from 'jquery';

import useMiniCartStore from '@global/stores/useMiniCartStore';
import useAlert from '@global/composable/useAlert';
import useMsg from '@global/composable/useMessage';
import usePopup from '@global/composable/usePopup';
import useModalStore from '@global/stores/useModalStore';

import NewImage from '@global/components/common/Image/NewImage.vue';
import AlertDialog from '@global/components/common/alert/AlertDialog.vue';
import Message from '@global/components/common/message/Message.vue';
import Popup from '@global/components/common/popup/Popup.vue';
import Modal from '@global/components/common/modal/Modal.vue';
import MarqueeComponent from '@components/MarqueeComponent.vue';

import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';
import GlobalCtrl from './globalCtrl';

const pinia = createPinia();
const { alertDialog } = useAlert();
const { popupDialog } = usePopup();
const { messageBox } = useMsg();

global.$ = require('jquery');

global.jQuery = global.$;

require('sticky-kit/dist/sticky-kit');

const app = createApp({
  components: {
    NewImage,
    AlertDialog,
    Popup,
    Message,
    Modal,
    MarqueeComponent,
  },
  setup() {
    const miniCartStore = useMiniCartStore();
    const modalStore = useModalStore();
    const { modalName } = storeToRefs(modalStore);

    const {
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      temperaturesData,
      dataIsLoad,
      count,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,
    } = storeToRefs(miniCartStore);

    const { getCartInfo, getHotSearch } = miniCartStore;

    const cartContentHeight = ref('');
    const hasProduct = ref(0);

    watch(totalCount, (val) => {
      onSetCartHeight();
    });

    watch(hotLoad, (val) => {
      if (val && window.location.pathname.includes('search')) {
        fireSearchListEvent(hotSearch.value);
      }
    });

    function onSetCartHeight() {
      if (totalCount.value !== 0) {
        if (isOnlyOneTemp.value && generalCount.value !== 0) {
          if (temperaturesData.value[0].Markets.length > 4) {
            cartContentHeight.value = `${(4 * 90).toString()}px`;
            document.getElementById('miniCart-all').style.overflowY = 'scroll';
          } else {
            cartContentHeight.value = `${(
              temperaturesData.value[0].Markets.length * 90
            ).toString()}px`;
          }
          document.getElementById('miniCart-all').style.height = cartContentHeight.value;
        } else {
          if (generalCount.value !== 0) {
            hasProduct.value += 1;
          }

          if (refrigerationCount.value !== 0) {
            hasProduct.value += 1;
          }

          if (freezingCount.value !== 0) {
            hasProduct.value += 1;
          }
          cartContentHeight.value = `${(hasProduct.value * 57.5).toString()}px`;

          hasProduct.value = 0;
          if (!document.getElementById('miniCart-all')) return;
          document.getElementById('miniCart-all').style.height = cartContentHeight.value;
        }
      }
    }

    function goSearch(item) {
      window.location.href = `/search?Keyword=${item}`;

      fireSearchEvent({
        isHotSearch: true,
        keyword: item,
      });
    }

    function goInputSearch(event) {
      const $input = $(event.currentTarget).closest('#searchForm').find('.hot-input'); // search-area 是你包住 input 和按鈕的容器
      const keyword = $input.val();
      console.log(keyword);
      if (keyword.length === 0) {
        popupDialog.alert('請輸入文字', '貼心提醒');
        event.preventDefault();
      } else {
        window.location.href = `/search?Keyword=${keyword}`;

        fireSearchEvent({
          isHotSearch: false,
          keyword: keyword,
        });
      }
    }

    function spread() {
      $('.hot-input-block').addClass('open');
      $('.hot-cancel').css('display', 'block');
    }

    function cancel() {
      $('.hot-input-block').removeClass('open');
      $('.hot-cancel').css('display', 'none');
      $('.hot-input').val('');
    }

    getCartInfo();
    getHotSearch();

    return {
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      temperaturesData,
      dataIsLoad,
      count,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,

      cartContentHeight,
      hasProduct,
      onSetCartHeight,
      goSearch,
      goInputSearch,
      spread,
      cancel,
      modalName,
    };
  },
});

app.use(pinia).mount('#app-mini-cart');

GlobalCtrl();

// 全域方法前後端使用
window.AlertDialog = alertDialog;
window.messageBox = messageBox;
